import DataCache from './core/data-cache'
import rootCache from './core/root-cache'
import { mapCache, mapRootCache } from './utils/map-cache'

// 插件-缓存相关
const install = function(Vue, options = {}) {
    var { router } = options
    
    // config
    Object.keys(DataCache.options).forEach(k => {
        if (options[k]) {
            DataCache.options[k] = options[k]
        }
    })
    
    // rootCache
    rootCache.setOptions(Object.assign({}, DataCache.options, {
        path: DataCache.options.rootPath,
        cache: DataCache.options.rootCache,
    }))
    
    // router 
    if (router) {
        router.beforeEach((to, from, next) => {
            // 注入$cache
            Object.defineProperty(to.meta, "$cache", {
                // 不可枚举，值可以更改
                writable: true,
                value: DataCache.fromRoute(to)
            })
            next()
        })
    }
    
    // Vue
    Vue.mixin({
        beforeCreate() {
            // 注入全局缓存对象
            this.$rootCache = rootCache
            
            if (this.$route) {
                // 注入路由缓存对象
                this.$cache = this.$route.meta.$cache
            }
        }
    })
    
    Vue.$rootCache = rootCache
}

export default install
export { rootCache, mapCache, mapRootCache }